import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {localization} from '../../Frames/localization'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
    });
  function Data(props)
    {
     var rows = 
        props.data.skuDiscounts.map(item => (
          createData(item.skuId, item.skuIdDesc, item.lastMonthDiscount.description, item.currentDiscount.description, item.nextMonthDiscount.description)
        ))
    
      return rows;
    }
  function createData(skuId,skuIdDesc, Discount_lastMonth, Discount_currentMonth, Discount_futureMonth) {
    return { skuId,skuIdDesc, Discount_lastMonth, Discount_currentMonth, Discount_futureMonth };
  }
  
  export default function SimpleTable(props) {
    const classes = useStyles();
    const rows = Data(props)
    var tr = {
      Nomenclature: localization.GetTranslate('Statistics.Nomenclature'),
      Last_months_discount: localization.GetTranslate('Statistics.Last months discount'),
      Discount_this_month: localization.GetTranslate('Statistics.Discount this month'),
      Discount_next_month: localization.GetTranslate('Statistics.Discount next month'),
    }
    return (
        <div className={props.className}>
                <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                    <TableCell>{tr.Nomenclature}</TableCell>
                    <TableCell align="center">{tr.Last_months_discount}</TableCell>
                    <TableCell align="center">{tr.Discount_this_month}</TableCell>
                    <TableCell align="center">{tr.Discount_next_month}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                    <TableRow key={row.skuId}>
                        <TableCell component="th" scope="row">{row.skuIdDesc}</TableCell>
                        <TableCell align="center">{row.Discount_lastMonth}</TableCell>
                        <TableCell align="center">{row.Discount_currentMonth}</TableCell>
                        <TableCell align="center">{row.Discount_futureMonth}</TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
      </div>
    );
  }